module.exports = __webpack_public_path__ + "img/140.3e8ab719.jpg";